import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Package, ShoppingCart, Users, FileText, MapPin, Tags, LogOut, Flame, Zap, Sparkles } from "lucide-react";

const NAV = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/products", icon: Package, label: "Products" },
  { to: "/admin/categories", icon: Tags, label: "Categories & Brands" },
  { to: "/admin/orders", icon: ShoppingCart, label: "Orders" },
  { to: "/admin/customers", icon: Users, label: "Customers" },
  { to: "/admin/spins", icon: Zap, label: "Spin & Win" },
  { to: "/admin/tryon", icon: Sparkles, label: "Try-On Settings" },
  { to: "/admin/content", icon: FileText, label: "Content (About/Help)" },
  { to: "/admin/pickup", icon: MapPin, label: "Pickup Locations" },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen grid grid-cols-[260px_1fr] bg-slate-50">
      <aside className="bg-[#0F172A] text-white p-4 flex flex-col">
        <div className="flex items-center gap-2 px-2 py-3 mb-4">
          <span className="grid place-items-center w-9 h-9 rounded-xl bg-[#004BCA]"><Flame size={18}/></span>
          <span className="font-display font-bold text-lg">Stylefire <span className="text-xs font-normal text-slate-300">Admin</span></span>
        </div>
        <nav className="space-y-1 flex-1">
          {NAV.map(n => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]+/g,"-")}`}
              className={({isActive})=>`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium ${isActive?"bg-[#004BCA] text-white":"text-slate-300 hover:bg-white/5"}`}>
              <n.icon size={16}/> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 pt-3 mt-3 text-xs">
          <div className="text-slate-300 truncate">{user?.email}</div>
          <button data-testid="admin-logout" onClick={async()=>{await logout(); nav("/admin/login");}} className="mt-3 inline-flex items-center gap-2 text-red-400"><LogOut size={14}/> Sign out</button>
        </div>
      </aside>
      <main className="p-6 lg:p-8 overflow-auto"><Outlet/></main>
    </div>
  );
}
